import en from './en/translation.json';

type JsonValue = string | { [key: string]: JsonValue };

function appendTmp(obj: JsonValue): JsonValue {
  if (typeof obj === 'string') return obj + '_tmp';
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, appendTmp(v)]));
}

export const enTmp = appendTmp(en as JsonValue) as typeof en;
